<div class="datepicker-wrap">
  <label for="myDatepicker" *ngIf="!isWithoutLabel">{{ 'all-reports.datePickerLabel' | translate }}</label>
  <mat-form-field>
    <input readonly matInput id="myDatepicker" [matDatepicker]="myDatepicker"
           (dateChange)="onChangeSelectedDate($event)">
    <mat-datepicker-toggle matSuffix [for]="myDatepicker"></mat-datepicker-toggle>
    <mat-datepicker #myDatepicker></mat-datepicker>
  </mat-form-field>
</div>

